if (!customElements.get('vfitz-usm-garage')) {
  customElements.define(
    'vfitz-usm-garage',
    class VfitzUSMGarage extends HTMLElement {

      constructor() {
        super();
        // console.log('###',this.dataset)
        this.showLevels=[];
        this.enabelShowLevels = "true" == this.dataset.enabelLevels ? true : false;
        this.vechile_null_text = " ";
        this.level0_maxsize = parseInt(this.dataset.size) || 2;
        this.searchParamsAllowKeys = ['make', 'model', 'sub_model', 'year', 'engine'];
        console.log('vfitz-usm-garage: version:1.0.0.1',this);      
      }
      connectedCallback(){
        this.classList.add('loading');
        if(!this.querySelector('div.vfitz-nav')){
          this.initLayout(); 
        }
        if(!window.vfitzEvents){
          window.vfitzEvents={};
          window.vfitzEvents['vfitz3MenuChange-loaded']=[];
        }
        window.addEventListener('vfitzInitMenuFirst', this.eventOnVfitzInitMenuFirst.bind(this));
        window.addEventListener('vfitzCustomSearchSubmit', this.eventOnVfitzCustomSearchSubmit.bind(this));
        window.addEventListener('vfitz3MenuChange', this.vfitzMenuChange.bind(this));
        window.addEventListener('vfitz3MenuChange-loaded', this.vfitz3MenuChangeLoaded.bind(this));
       
        console.log(`vfitz-usm-garage.js => document.querySelector('.vfitz-custom-layout.user-custom').style.display`,document.querySelector('.vfitz-custom-layout.user-custom').style.display);
        try {
          if("" == document.querySelector('.vfitz-custom-layout.user-custom').style.display){
            this.eventOnVfitzInitMenuFirst({});
          }
        } catch (error) {
          console.warn(error)
        }
      }
      disconnectedCallback() {
        window.removeEventListener('vfitzInitMenuFirst', this.eventOnVfitzInitMenuFirst);
        window.removeEventListener('vfitzCustomSearchSubmit', this.eventOnVfitzCustomSearchSubmit); 
        window.removeEventListener('vfitz3MenuChange', this.vfitzMenuChange);
        window.removeEventListener('vfitz3MenuChange-loaded', this.vfitz3MenuChangeLoaded);
        try {
          window?.vfitzEvents['vfitz3MenuChange-loaded'].splice(window.vfitzEvents['vfitz3MenuChange-loaded'].indexOf(this.vfitz3MenuChangeLoaded));
        } catch (error) {}
      }

      initLayout(){

        this.dom_headerNav = document.createElement('div');
        this.dom_headerNav.className=`vfitz-nav ${this.enabelShowLevels ? 'levels' :'no-levels'}`;
        this.append(this.dom_headerNav);

        this.dom_menudrop = document.createElement('div');
        this.dom_menudrop.className="menudrop animate--slide-in";
        this.dom_headerNav.append(this.dom_menudrop);

        this.dom_dropGarage = document.createElement('div');
        this.dom_dropGarage.className="drop-garage animate--slide-in";
        this.dom_headerNav.append(this.dom_dropGarage);
        
        this.dom_navLabel = document.createElement('div');
        this.dom_navLabel.className="nav-label";
        this.dom_headerNav.append(this.dom_navLabel);

        this.dom_navLabel_vechile = document.createElement('div');
        this.dom_navLabel_vechile.className="nav-label-vechile";
        this.dom_navLabel.append(this.dom_navLabel_vechile);        

        this.dom_navLabel_close = document.createElement('div');
        this.dom_navLabel_close.className="nav-label-close";
        this.dom_navLabel_close.innerHTML='<svg class="garage-svg"><use href="#mc-icon-close"></use></svg>';

        this.dom_vechile_label = document.createElement('div');
        this.dom_vechile_label.className="vechile-label";
        
        this.dom_navLabel_vechile.append(this.dom_vechile_label);
        this.dom_navLabel_vechile.append(this.dom_navLabel_close);
        
        this.dom_showLevels = document.createElement('div');
        this.dom_showLevels.className="show-levels";
        this.dom_headerNav.append(this.dom_showLevels);

        // this.dom_navGarage = document.createElement('div');
        // this.dom_navGarage.className="nav-garage";
        // this.dom_navGarage.innerHTML='<svg class="garage-svg" style="width:1.5em;"><use href="#mc-icon-vehicle"></use></svg>';
        // this.dom_headerNav.append(this.dom_navGarage);

        const dom_navGarage = '<div class="nav-garage"><svg class="garage-svg" style="width:1.5em;"><use href="#mc-icon-vehicle"></use></svg></div>';
        this.dom_navLabel.insertAdjacentHTML('beforeend', dom_navGarage);
        this.dom_headerNav.insertAdjacentHTML('beforeend', dom_navGarage);   
        this.querySelectorAll('.nav-garage').forEach(e=>e.onclick=()=>{this.toggleDorpGarage();})

        this.dom_navLabel_close.onclick=()=>{
          this.dom_vechile_label.innerText = this.vechile_null_text;
          this.dom_headerNav.classList.remove('has-vechile');
        }

        this.dom_vechile_label.onclick=()=>{
          if(this.dom_vechile_label.innerText.length > 2){
            vfitz$(`#vfitz_search_btn${vfitz.config.selectorScope}`).click(); 
          }
        }
      }

      toggleDorpGarage(falg){
        if('hidden' == falg){
          this.dom_dropGarage.removeAttribute('open'); 
        }else{
          if(this.dom_dropGarage.hasAttribute('open')){
           this.dom_dropGarage.removeAttribute('open'); 
          }else{
            this.dom_dropGarage.setAttribute('open','')
          }
        }      
      }
      
      eventOnVfitzInitMenuFirst(event) {
        // console.log('eventOnVfitzInitMenuFirst', event);
        if(this.enabelShowLevels){
          this.getLevelValues();
          this.dom_menudrop.append(document.querySelector('.vfitz-section-3'));
        }else{
          this.dom_showLevels.append(document.querySelector('.vfitz-section-3'));
        }
        document.querySelector('.vfitz-section-3').style.display = 'block';
        this.getUserGarageFirst();
        this.renderGarageList();
        vfitz$(`${vfitz.config.selectorScope} [vfitz_id="${vfitz.config.level_ids[vfitz.config.level_ids.length-1]}"]`).on("change", function(event){vfitz$(`#vfitz_search_btn${vfitz.config.selectorScope}`).click();})
      }

      eventOnVfitzCustomSearchSubmit(event) {
        // console.log('eventOnVfitzCustomSearchSubmit', event.detail, { searchParams });
      }

      getLevelValues(){
        const level_0 = [];
        // document.querySelectorAll(`${vfitzKey.fn.vfitz_func_getSelectorbyIndex(0)} option[value]`).forEach(v=>{level_0.push({lable:v.innerText,value:v.value})});
        const _options = document.querySelectorAll(`${vfitzKey.fn.vfitz_func_getSelectorbyIndex(0)} option[value]`);
        let _size = this.level0_maxsize < _options.length ? this.level0_maxsize : _options.length;
        for(let i=0; i<_size; i++){
          if(_options[i].value.length < 2){
            _size=_size+1;
          }else{
            level_0.push({lable:_options[i].innerText,value:_options[i].value});
          }
        }

        if( this.level0_maxsize < _options.length ){
          level_0.push({lable:"More",value:"more"})
        }
        this.showLevels = level_0;
        this.renderShowLevel();
      }

      renderShowLevel(){
        const ele = this.showLevels.map(v=>`<div class="item" data-value="${v.value}">${v.lable}</div>`);
        this.dom_showLevels.innerHTML= ele.join('');
        const that = this;
        document.querySelectorAll('.show-levels>.item').forEach(e=>{
          e.onclick=(ev)=>{this.handelShowLevelItem(ev)}
          // e.removeEventListener('click',that.handelShowLevelItem);
          // e.addEventListener('click',that.handelShowLevelItem.bind(that));
        })
      }

      handelShowLevelItem(event){
        // console.log('handelShowLevelItem', {target:event.target}, event.target.attributes.selected);
        if(event.target.attributes.selected){return false;}
        document.querySelectorAll('.show-levels .item[data-value]').forEach(e=>e.removeAttribute('selected'));
        event.target.setAttribute('selected','');
        this.dom_menudrop.className='menudrop animate--slide-in';
        this.toggleDorpGarage('hidden');
        if(this.dom_menudrop.hasAttribute('open')){
         // this.dom_menudrop.removeAttribute('open'); 
        }else{
          this.dom_menudrop.setAttribute('open','')
        }

        setTimeout(()=>{
          if("more"==event.target.dataset.value){
            // console.log('more .... ')
            vfitz$(vfitzKey.fn.vfitz_func_getSelectorbyIndex(0)).val(null).trigger('change');
          }else{
             vfitz$(vfitzKey.fn.vfitz_func_getSelectorbyIndex(0)).val(event.target.dataset.value).trigger('change'); 
          }          
        },100); 
      }

      vfitzMenuChange(event){
        // console.log('vfitzMenuChange', event.detail.index);
        // const _zero = document.querySelector('.show-levels [data-value="more"][selected]') ? true : false;
        // console.log(_zero);
        // this.dom_menudrop.className=`menudrop animate--slide-in ${this.generateArray(1 + event.detail.index, _zero).map(v=>`s${v}`).join(' ')}`;
        // // this.dom_menudrop.className.add(this.generateArray(event.detail.index+1).map(v=>`s${v}`));
      }

      vfitz3MenuChangeLoaded(event){
        // console.log('vfitz3MenuChange-loaded',event);
        if(event?.detail?.loadedData?.length == 0){
          // vfitz$(`#vfitz_search_btn${vfitz.config.selectorScope}`).click();
        }else{
          const _zero = document.querySelector('.show-levels [data-value="more"][selected]') ? true : false;
          // const _endNum = _zero ?  event.detail.index : 1 + event.detail.index;
          let _endNum = 1 + event.detail.index;
          if(0 == event?.detail?.index &&  "" == event?.detail?.value){ _endNum = 0; }
          this.dom_menudrop.className=`menudrop animate--slide-in ${this.generateArray(_endNum, _zero).map(v=>`s${v}`).join(' ')}`;          
        }
      }

      renderVechileInfo(){
        // console.log('renderVechileInfo', this)
        const params = searchParams;
        const lable = this.getVechileInfo(params);
        if(lable.length>3){
          this.dom_vechile_label.innerText = lable;
          this.dom_headerNav.classList.add('has-vechile');
        }else{
          this.dom_vechile_label.innerText = this.vechile_null_text;
          this.dom_headerNav.classList.remove('has-vechile');
        }
      }

      getVechileInfo(params){
        const _data = {};
        const _params = Object.keys(params).filter(v => this.searchParamsAllowKeys.includes(v) && params[v].length > 0).forEach(k => {_data[k] = params[k];});
        const _label = vfitz.config.level_ids.map(k=>_data[k]).join(' ').replace(/-/g, ' ');
        return _label;
      }

      // searchParams(){
      //   const that = this;
      //   const _data = {};
      //   Object.keys(searchParams).filter(v => that.searchParamsAllowKeys.includes(v) && searchParams[v].length > 0).forEach(k => {_data[k] = searchParams[k];});
      //   return _data;
      // }
      
      getUserGarageFirst() {
        try {
          this.cookieValue = vfitzKey.fn.getGarageData()[0];
          this.garage_param = this.cookieValue.param;
          if (this.cookieValue.param) {
            window.searchParams = this.garage_param;
            this.renderVechileInfo();
          }
        } catch (e) {
          console.error(e);
        }
      }

      handleGarageItem(event){
        const garageid = event.dataset.garageid;
        // console.log('handleGarageItem', event.dataset.garageid, vfitzKey.fn.getGarageData()[garageid]);
        window.searchParams = vfitzKey.fn.getGarageData()[garageid].param;
        vfitz$(`#vfitz_search_btn${vfitz.config.selectorScope}`).click();
      }

      handelRemoveGarageByIndex(index){
        // console.log('handelRemoveGarageByIndex', {index});
        if(index>=0){vfitzKey.fn.removeGarageDataByIdx(index);}
        this.renderGarageList();
      }
      
      renderGarageList() {
        try {
          const that = this;
          const garages = vfitzKey.fn.getGarageData();
          const ele_garages = []
          garages.map((v,idx)=>{
            ele_garages.push(`<div class="gar-item" data-garageid=${idx}><span lable>${this.getVechileInfo(v.param)}</span><svg ctl class="garage-svg"><use href="#mc-icon-remove"></use></svg></div>`);
          })
          if(ele_garages.length>0){
            this.dom_dropGarage.innerHTML= '<div class="gar-layout">'+ ele_garages.join(' ')+'</div>';
            this.dom_dropGarage.querySelectorAll('.gar-item[data-garageid]').forEach(e=>{
              e.querySelector('[lable]').onclick=()=>{this.handleGarageItem(e);}
              e.querySelector('[ctl]').onclick=()=>{this.handelRemoveGarageByIndex(e.dataset.garageid)};
            })
          }else{
            this.dom_dropGarage.innerHTML= '<div class="gar-layout"><div class="gar-item">NO CARS IN YOUR GARAGE!</div></div>';
          }
          this.classList.remove('loading');
        } catch (e) { }
      }

      generateArray(n, startZero) {
        let arr = [];
        let i = 1;
        if(startZero){ i = 0;}
        for ( i; i <= n; i++) {
          arr.push(i);
        }
        // console.log({arr})
        return arr;
      }
      
    })
}